import React, { useEffect, useState } from "react";

import Input from "../../../../UI/Input/Input";
import { checkValidity } from "../../../../shared/utility";
import classes from "./IncidentDetails.css";
import { connect, useSelector, useDispatch } from "react-redux";
import ReactTooltip from "react-tooltip";
import { DISABLE_REASONS } from "../../../../shared/Constants";
import * as actions from "../../../../store/actions";

const IncidentDetails = (props) => {
  const [valid, setValid] = useState(false);
  const dispatch = useDispatch();
  const reasonList = useSelector((state) => state.member.disableReasons);
  const reasonFailure = useSelector((state) => state.member.getReasonFailure);
  const [incidentDetailForm, setIncidentDetailForm] = useState({
    incidentNumber: {
      elementType: "input",
      elementConfig: {
        type: "text",
        id: "incidentNumber",
        placeholder: "incidentNumber*",
        rows: 5,
        cols: 150,
        minLength: 2,
        maxLength: 1275,
      },
      value: props.incidentNumber ?? "",
      validation: {
        required: true,
        minlength: 2,
        maxlength: 1275,
      },
      disabled: true,
      valid: true,
      touched: false,
      label: "Incident Number",
      inputType: "QuickSearch",
    },
    incidentStatus: {
      elementType: "select",
      elementConfig: {
        type: "text",
        id: "incidentStatus",
        placeholder: "Select One",
        options: [
          { value: 1, displayValue: "Opened" },
          { value: 2, displayValue: "Resolved" },
        ],
      },
      value: 1,
      validation: {
        required: true,
      },
      disabled: props.impactedMemberData ? true : false,
      valid: false,
      touched: false,
      label: "Incident Status",
      inputType: "QuickSearch",
    },
  });
  const inputChangedHandler = (event, inputIdentifier) => {
    let updatedForm = { ...incidentDetailForm };

    const updatedFormElement = { ...updatedForm[inputIdentifier] };
    updatedFormElement.value = event.target.value;
    let formIsValid = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    if (event.target.value) {
      const validation = checkValidity(
        updatedFormElement.value,
        updatedFormElement.validation
      );
      updatedFormElement.valid = validation.isValid;
    } else {
      updatedFormElement.valid = false;
    }
    if (inputIdentifier === "reason" && event.target.value === "Other") {
      updatedForm["description"].validation.required = true;
      const validationDescription = checkValidity(
        updatedForm["description"].value,
        updatedForm["description"].validation
      );
      updatedForm["description"].valid = validationDescription.isValid;
    } else {
      updatedForm["description"].validation.required = false;
      updatedForm["description"].valid = true;
    }
    setValid(updatedFormElement.valid);
    updatedFormElement.touched = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    }
    setIncidentDetailForm(updatedForm);
    props.setDescriptionDetails(updatedForm);
  };

  // useEffect(() => {
  //   if (
  //     incidentDetailForm.incidentNumber.valid &&
  //     incidentDetailForm.incidentStatus.valid
  //   ) {
  //     props.isValid(true);
  //   } else {
  //     props.isValid(false);
  //   }
  // }, [incidentDetailForm]);

  useEffect(() => {
    const updatedForm = {};
    Object.keys(incidentDetailForm).map((key) => {
      const formCopy = { ...incidentDetailForm[key] };
      formCopy.disabled = formCopy.disabled || props.formDisabled;
      updatedForm[key] = formCopy;
    });
    setIncidentDetailForm(updatedForm);
  }, [props.formDisabled]);

  // useEffect(() => {
  //   props.setDescriptionDetails(incidentDetailForm);
  // }, []);

  const incidentDetailFormDisplay = Object.keys(incidentDetailForm).map(
    (key) => {
      const descriptionElement = incidentDetailForm[key];
      return (
        <div
          style={{
            display: "flex",
            // flexFlow: "column",
            // flex: "50%",
            margin: "10px",
          }}
          className="required-field"
        >
          <Input
            key={key}
            elementType={descriptionElement.elementType}
            elementConfig={descriptionElement.elementConfig}
            value={descriptionElement.value}
            invalid={!descriptionElement.valid}
            shouldValidate={descriptionElement.validation}
            touched={descriptionElement.touched}
            disabled={descriptionElement.disabled}
            label={descriptionElement.label}
            changed={(event) => inputChangedHandler(event, key)}
            inputType={descriptionElement.inputType}
          />
        </div>
      );
    }
  );

  return (
    <>
      <div className={classes.FormTitle}>{"Incident Details"}</div>
      <div className={classes.box}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {incidentDetailFormDisplay}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    impactedMemberData: state.member.impactedMemberData,
    incidentNumber: state.serviceNow.incidentNumber,
  };
};

export default connect(mapStateToProps, null)(IncidentDetails);
